import React from 'react';
import 'antd/lib/date-picker/style/css';
import '../../../../public/css/antdCustom.css';
import { Form, Alert, Input, Button, Select, Switch, DatePicker, LocaleProvider, InputNumber, Tooltip, Icon, Radio, Row, Col } from 'antd';
import request from 'superagent';
import Constants from '../../../commons/Constants';
import enUS from 'antd/lib/locale-provider/en_US';
import moment from 'moment';

const FormItem = Form.Item;
const Option = Select.Option;

const SPECIAL_TENANT_ID = [
    '00000000-0000-4000-8000-000000000000',
    '00000000-0000-4000-8000-000000000001'
];

class DiagnosticsForm extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            tenants: [],
            tenantsDefault: [],
            status: Constants.STATUS.init,
            errorMessage: '',
            showAdvance: false
        };
    }

    componentDidMount() {
        this.getTenantIds();
    }

    handleSubmit = (e) => {
        e.preventDefault();
        this.props.form.validateFields((err, values) => {
            if (!err) {
                console.log('Received values of form: ', values);
                const allFields = values;
                const timeType = allFields.timeType;
                const traceSearchBy = allFields.traceSearchBy;
                let ts = '';
                if (timeType === 'ts') {
                    let timestamp = allFields.timeInputDirect.trim();
                    timestamp = timestamp.replace(" +", "+").replace(" -", "-");
                    ts = moment(timestamp);
                } else {
                    ts = allFields.timeInput;
                }

                if (ts && !ts.isValid()) {
                    this.setState({
                        status: Constants.STATUS.error,
                        errorMessage: "Invalid timestamp format."
                    });
                    return;
                }

                const data = {
                    //ts: (ts.toDate()).toISOString(),
                    //before: before,
                    //after: after,
                    query: {}
                };

                if (ts) {
                    data.ts = (ts.toDate()).toISOString();
                }
                if (allFields.beforeInput) {
                    data.before = allFields.beforeInput + "m";
                }
                if (allFields.afterInput) {
                    data.after = allFields.afterInput + "m";
                }
                if (allFields.tenantIdInput) {
                    data.query["json.tid"] = "/" + allFields.tenantIdInput + "/";
                }
                if (allFields.serviceNameInput) {
                    data.query["collection"] = "/" + allFields.serviceNameInput + "/";
                }
                if (allFields.sourceInput) {
                    data.query["source"] = "/" + allFields.sourceInput + "/";
                }
                if (allFields.onlyErrorInput) {
                    data.query["json.level"] = "ERROR";
                }
                if (allFields.traceid) {
                    data.query["traceid"] = allFields.traceid;
                }
                if (allFields.serialNumber) {
                    data.query["serialNumber"] = allFields.serialNumber;
                }

                console.log(data);
                this.setState({status: Constants.STATUS.trying});

                let url = '/api/logdownloader/search';
                if (traceSearchBy === 'ti') {
                    url = '/api/logdownloader/searchbytraceid';
                } else if (traceSearchBy === 'sn') {
                    url = '/api/logdownloader/searchbysn';
                }
                request.post(url)
                    .withCredentials()
                    .set('Content-Type', 'application/json; charset=utf-8')
                    .send(data)
                    .end((error, response) => {
                        if (!error && response) {
                            const file_path = "/api/logdownloader/download?fileName=" + response.body.fileName;
                            let a = document.createElement('A');
                            a.href = file_path;
                            a.download = file_path;
                            document.body.appendChild(a);
                            a.click();
                            document.body.removeChild(a);
                            this.setState({status: Constants.STATUS.done});
                        } else {
                            console.error("error while searching logs.", error);
                            if (error.status === 506) {
                                this.setState({
                                    status: Constants.STATUS.error,
                                    errorMessage: "Too many records to download. Please input more criteria or select a shorter period of time."
                                });
                            } else {
                                this.setState({
                                    status: Constants.STATUS.error,
                                    errorMessage: "Error while searching logs."
                                });
                            }
                        }
                    })
            }
        });
    }

    checkTimestamp = (rule, value, callback) => {
        if (value !== "" && (value < 1 || value > 120)) {
            callback('The duration is from 1 to 120.');
        } else {
            callback();
        }
    }

    checkTimeInputDirect = (rule, value, callback) => {
        if (!value) {
            callback();
        } else {
            const timestamp = value.replace(" +", "+").replace(" -", "-");
            const ts = moment(timestamp);
            if (!ts.isValid()) {
                callback('Invalid timestamp format.');
            } else {
                callback();
            }
        }
    }

    changeAdvancedFilters = (value) => {
        this.setState({ showAdvance: value });
        if (value === false) {
            this.props.form.setFieldsValue({
                tenantIdInput: '',
                serviceNameInput: '',
                sourceInput: '',
                onlyErrorInput: false
            });
        }
    }

    resetCriteria = (e) => {
        this.setState({ status: Constants.STATUS.init });
        if (e.target.value === 'ti') {
            this.changeAdvancedFilters(false);
        }
    }

    getTenantIds = () => {
        let tenants = [];
        request.get('/api/tenant-manager')
            .withCredentials()
            .end((error, response) => {
                if (!error && response) {
                    const data = response.body.tenants;
                    for (let i = 0; i < data.length; i++) {
                        tenants.push({
                            value: data[i].tenantId,
                            label: data[i].companyName + " (" + data[i].tenantDomain + ")"
                        });
                    }
                    for (let i = 0; i < SPECIAL_TENANT_ID.length; i++) {
                        tenants.push({value: SPECIAL_TENANT_ID[i], label: SPECIAL_TENANT_ID[i]});
                    }
                    this.setState({tenants});
                } else {
                    this.setState({tenants});
                    console.error("error while fetching tenants ", error);
                }
            });
    }

    render() {
        const { getFieldDecorator } = this.props.form;
        const { tenants, showAdvance } = this.state;
        const formItemLayout = { labelCol: {sm: {span: 5}}, wrapperCol: {sm: {span: 5}} };
        const tailFormItemLayout = {
            wrapperCol: {sm: {span: 14, offset: 0}}
        };
        const form = this.props.form;

        const tenantComp =
            tenants && tenants.length > 0 ?
                <Select size="large" placeholder="Select a tenant from list." showSearch
                        filterOption={(input, option) => option.props.children.toLowerCase().indexOf(input.toLowerCase()) >= 0}
                        onChange={(event) => {form.setFieldsValue({"tenantIdInput": event})}}>
                    <Option key="" value="">All tenants</Option>
                    {
                        tenants.sort((t1, t2) => {
                            return t1.label.toLowerCase() === t2.label.toLowerCase() ? 0 : (t1.label.toLowerCase() > t2.label.toLowerCase() ? 1 : -1);
                        }).map((data) => {
                            return <Option key={data.value}
                                           value={data.value}>{data.label}</Option>
                        })
                    }
                </Select>
                :
                null;

        return (
            <div className="page-container">
                <h2 className="page-title">Diagnostics</h2>

                <div>
                    <div style={{marginBottom: 10}}>
                        <Alert style={{ display: this.state.status === Constants.STATUS.done ? 'block' : 'none' }}
                               message="Success" description="Succeed to download logs." type="success" showIcon/>
                        <Alert style={{ display: this.state.status === Constants.STATUS.trying ? 'block' : 'none' }}
                               message="Searching..." description="It takes a while to query and download. Be patient."
                               type="info" showIcon/>
                        <Alert style={{ display: this.state.status === Constants.STATUS.error ? 'block' : 'none' }}
                               message="Error" description={this.state.errorMessage} type="error" showIcon/>
                    </div>
                    <div style={{ display: this.state.status !== Constants.STATUS.trying ? 'block' : 'none' }}>
                        <Form onSubmit={this.handleSubmit}>
                            <FormItem labelCol={{sm: { span: 5 }}}
                                      wrapperCol={{sm: { span: 12 }}} label="Search By">
                                {getFieldDecorator('timeType', {
                                    initialValue: 'dt'
                                })(
                                    <Radio.Group onChange={this.resetCriteria}>
                                        <Radio.Button value="dt">Date&amp;Time</Radio.Button>
                                        <Radio.Button value="ts">Timestamp</Radio.Button>
                                        <Radio.Button value="ti">PDMS-E Trace ID</Radio.Button>
                                    </Radio.Group>
                                )}
                            </FormItem>

                            {/********** Trace ID **********/}
                            { form.getFieldValue("timeType") === 'ti' && (
                                <FormItem labelCol={{sm: { span: 5 }}}
                                          wrapperCol={{sm: { span: 12 }}} label="Mode">
                                    {getFieldDecorator('traceSearchBy', {
                                        initialValue: 'ti'
                                    })(
                                        <Radio.Group>
                                            <Radio value="ti">By Trace ID</Radio>
                                            <Radio value="sn">By Serial Number</Radio>
                                        </Radio.Group>
                                    )}
                                </FormItem>
                            )}

                            {/********** dateTime **********/}
                            { (form.getFieldValue("timeType") === 'dt'
                            || form.getFieldValue("traceSearchBy") === 'sn') &&
                            <LocaleProvider locale={enUS}>
                                <FormItem {...formItemLayout}
                                    label={(
                                         <span>Select Date &amp; Time&nbsp;
                                              <Tooltip title={
                                                  <div>
                                                      <small style={{display: 'block'}}>
                                                      Times entered via the "Date&amp;Time" option are considered to be in your local time zone.
                                                      </small>
                                                  </div>}>
                                                  <Icon type="question-circle-o"/>
                                              </Tooltip>
                                         </span>
                                         )}>
                                    {getFieldDecorator('timeInput', {
                                        rules: [{
                                            type: 'object',
                                            required: true,
                                            message: 'Please select a date & time.'
                                        }]
                                    })(
                                        <DatePicker showTime format="YYYY-MM-DD HH:mm:ss" placeholder=""/>
                                    )}
                                </FormItem>
                            </LocaleProvider>
                            }

                            {/********** timestamp **********/}
                            { form.getFieldValue("timeType") === 'ts' &&
                            <FormItem {...formItemLayout}
                                label={(
                                      <span>
                                        Input Timestamps&nbsp;
                                          <Tooltip title={<div>
                                              <small style={{display: 'block'}}>e.g. Timestamps:</small>
                                              <small style={{display: 'block'}}>2017-04-18 09:34:43.435 (Pano log format)</small>
                                              <small style={{display: 'block'}}>2017-04-18 18:23:09,545 +0530 (Pano App log format)</small>
                                              <small style={{display: 'block'}}>2017-04-18T12:53:09.545Z (ISO)</small>
                                              </div>}>
                                            <Icon type="question-circle-o" />
                                          </Tooltip>
                                        </span>
                                  )}>
                                {getFieldDecorator('timeInputDirect', {
                                    rules: [{type: 'string', required: true, message: 'Please input a timestamp.'},
                                        {validator: this.checkTimeInputDirect}]
                                })(
                                    <Input placeholder="UTC or with Time Zone"/>
                                )}
                            </FormItem>
                            }

                            {/********** search criteria of datetime & timestamp **********/}
                            { (form.getFieldValue("traceSearchBy") === 'sn'
                            || form.getFieldValue("timeType") !== 'ti') &&
                            <div>
                                <FormItem {...formItemLayout} label="Capture Before">
                                    {getFieldDecorator('beforeInput', {
                                        initialValue: 10,
                                        rules: [{
                                            type: 'number',
                                            required: true,
                                            message: 'Please select a before time.'
                                        }, {validator: this.checkTimestamp}]
                                    })(
                                        <InputNumber min={1} max={120}/>
                                    )}
                                    <span className="ant-form-text"> minutes</span>
                                </FormItem>

                                <FormItem {...formItemLayout} label="Capture After">
                                    {getFieldDecorator('afterInput', {
                                        initialValue: 10,
                                        rules: [{
                                            type: 'number',
                                            required: true,
                                            message: 'Please select an after time.'
                                        }, {validator: this.checkTimestamp}]
                                    })(
                                        <InputNumber min={1} max={120}/>
                                    )}
                                    <span className="ant-form-text"> minutes</span>
                                </FormItem>
                            </div>
                            }

                            { form.getFieldValue("timeType") !== 'ti' && (
                                <FormItem {...formItemLayout} label="Advanced Filters">
                                    {getFieldDecorator('advancedFilters', {
                                        initialValue: false
                                    })(
                                        <Switch onChange={this.changeAdvancedFilters}/>
                                    )}
                                </FormItem>
                            )}

                            { showAdvance && (
                                <div>
                                    <Row>
                                        <Col span={10}>
                                            <FormItem labelCol={{sm: { span: 12 }}}
                                                      wrapperCol={{sm: { span: 12 }}}
                                                      label="Tenant">
                                                {getFieldDecorator('tenantIdInput', {})(<Input/>)}
                                            </FormItem>
                                        </Col>
                                        <Col span={6} style={{marginLeft: 5}}>
                                            {tenantComp}
                                        </Col>
                                    </Row>

                                    <FormItem {...formItemLayout} label="Service Name">
                                        {getFieldDecorator('serviceNameInput', {})(
                                            <Input />
                                        )}
                                    </FormItem>
                                    <FormItem {...formItemLayout} label="Source">
                                        {getFieldDecorator('sourceInput', {})(
                                            <Input />
                                        )}
                                    </FormItem>
                                    <FormItem {...formItemLayout} label="Only Error">
                                        {getFieldDecorator('onlyErrorInput', {
                                            valuePropName: 'checked',
                                            initialValue: false
                                        })(
                                            <Switch checkedChildren="Yes" unCheckedChildren="No"/>
                                        )}
                                    </FormItem>
                                </div>
                            )}

                            {/********** search criteria of trace ID **********/}
                            { form.getFieldValue("timeType") === 'ti' &&
                                <div>
                                    { form.getFieldValue("traceSearchBy") === 'ti' &&
                                        <FormItem {...formItemLayout} label="Trace ID">
                                            {getFieldDecorator('traceid', {
                                                rules: [{type: 'string', required: true, message: 'Please input a trace ID.'}]
                                            })(
                                                <Input placeholder="Trace ID"/>
                                            )}
                                        </FormItem>
                                    }
                                    { form.getFieldValue("traceSearchBy") === 'sn' &&
                                        <div>
                                            <Row>
                                                <Col span={10}>
                                                    <FormItem labelCol={{sm: { span: 12 }}}
                                                              wrapperCol={{sm: { span: 12 }}}
                                                              label="Serial Number">
                                                        {getFieldDecorator('serialNumber', {
                                                            rules: [{type: 'string', required: true, message: 'Please input a device serial number.'}]
                                                        })(
                                                            <Input placeholder="Serial Number"/>
                                                        )}
                                                    </FormItem>
                                                </Col>
                                            </Row>
                                            {/*<FormItem {...formItemLayout} label="Select Trace ID">
                                                { traceIdList.length > 0 &&
                                                    <div className="borderless">
                                                        <BootstrapTable ref="table" data={traceIdList}
                                                                        selectRow={ selectRowProp }
                                                                        condensed>
                                                            <TableHeaderColumn dataField='traceid' isKey>
                                                                Trace ID
                                                            </TableHeaderColumn>
                                                        </BootstrapTable>
                                                    </div>
                                                }
                                            </FormItem>*/}
                                        </div>
                                    }
                                </div>
                            }

                            <div className="hr-dashed"></div>
                            <FormItem {...tailFormItemLayout}>
                                <Button type="primary" htmlType="submit">
                                    Download
                                </Button>
                            </FormItem>
                        </Form>
                    </div>
                </div>
            </div>
        );
    }
}

const DiagnosticsViewAnt = Form.create()(DiagnosticsForm);
export default DiagnosticsViewAnt;


// WEBPACK FOOTER //
// ./src/modules/diagnostics/component/DiagnosticsViewAnt.js